import {createReducer, on} from '@ngrx/store';
import {FeatureFlagState} from '../models/feature-flag-state.model';
import * as FeatureFlagActions from './feature-flag.actions';

export const initialState: FeatureFlagState = {
  flags: [],
  loading: false,
  error: null,
};

export const featureFlagReducer = createReducer(
  initialState,
  on(FeatureFlagActions.loadFeatureFlags, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(FeatureFlagActions.loadFeatureFlagsSuccess, (state, {flags}) => ({
    ...state,
    loading: false,
    flags,
  })),
  on(FeatureFlagActions.loadFeatureFlagsFailure, (state, {error}) => ({
    ...state,
    loading: false,
    error,
  }))
);
